import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Card } from "@/components/ui/card";

type StatCardProps = {
  label: string;
  value: ReactNode;
  icon: LucideIcon;
  hint?: ReactNode;
};

/** KPI tile for dashboards. */
export function StatCard({ label, value, icon: Icon, hint }: StatCardProps) {
  return (
    <Card className="flex flex-col gap-3 p-5">
      <div className="flex items-center justify-between text-muted">
        <span className="font-medium">{label}</span>
        <span className="flex size-8 items-center justify-center rounded-lg bg-primary-soft text-primary">
          <Icon className="size-4" aria-hidden="true" />
        </span>
      </div>
      <div className="text-2xl font-semibold tracking-tight tabular-nums">{value}</div>
      {hint && <div className="text-xs text-muted">{hint}</div>}
    </Card>
  );
}
